module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('blockquote', {
    staticClass: "sink epigraph"
  }, [_c('p', {
    staticClass: "left "
  }, [_vm._v("Without thinking of good or evil, show me your original face before your mother and father were born.—"), _c('em', [_vm._v("Zen koan")])]), _vm._v(" "), _c('p', {
    staticClass: "left spaceabove2"
  }, [_vm._v("In abortion the person who is massacred, physically and morally, is the woman. For any man with a conscience every abortion is a moral ordeal that leaves a mark, but . . . every male should bite his tongue three times before speaking about such things.—"), _c('em', [_vm._v("Italo Calvino")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-133e2d69","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/front02.vue
// module id = 66
// module chunks = 0